module.exports = __webpack_public_path__ + "static/media/ai2html-graphic-mobile375.da5b0300.gif";